import { useEffect, useState } from "react";
import { toast } from "sonner";

export default function useWorkspaceAccess() {
  const [user, setUser] = useState(null);
  const [isPro, setIsPro] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const loadAccess = async () => {
      try {
        const [userResponse, entitlementResponse] = await Promise.all([
          fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
            credentials: "include",
          }),
          fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/payments/entitlement`,
            {
              credentials: "include",
            },
          ),
        ]);
        if (!userResponse.ok || !isMounted) return;
        const currentUser = await userResponse.json();
        const entitlement = entitlementResponse.ok
          ? await entitlementResponse.json()
          : { is_pro: false };
        if (!isMounted) return;
        setUser(currentUser);
        setIsPro(Boolean(entitlement.is_pro));
        const noticeKey = `pfjudgepro-founding-notice-${currentUser.user_id}`;
        const proNoticeKey = `pfjudgepro-pro-notice-${currentUser.user_id}`;
        if (currentUser.founding_member && !sessionStorage.getItem(noticeKey)) {
          toast.success(
            "You’re one of the Founding 25 — Pro is included for 30 days. Your feedback will help shape PFJudgePro.",
          );
          sessionStorage.setItem(noticeKey, "shown");
        } else if (entitlement.is_pro && !sessionStorage.getItem(proNoticeKey)) {
          toast.success(
            "Pro access is active. Your post-round tools, history, and exports are ready.",
          );
          sessionStorage.setItem(proNoticeKey, "shown");
        }
      } catch (error) {
        if (isMounted) setIsPro(false);
      }
    };
    loadAccess();
    return () => {
      isMounted = false;
    };
  }, []);

  return { isPro, user };
}
